import { OpenAPI } from 'api-clients/monolith';

import { domainMeta } from 'utils/domainMeta';

export const setupOpenApiClient = () => {
  OpenAPI.BASE = domainMeta.monolithOrigin;
  // @TODO probably want to configure this based on env?
  OpenAPI.WITH_CREDENTIALS = true;
};
